export default __webpack_public_path__ + "assets/mp3/9afdfed1f9b8aa787e83aa7667977d00.mp3";